import { connect, mapProps, mapReadPretty } from '@formily/react'
import { Checkbox as NextCheckbox } from '@alicloudfe/components'
import {
  CheckboxProps,
  GroupProps as CheckboxGroupProps,
} from '@alicloudfe/components/types/checkbox'
import { PreviewText } from '../preview-text'
import { mapSize } from '../__builtins__'

type ComposedCheckbox = React.FC<React.PropsWithChildren<CheckboxProps>> & {
  Group?: React.FC<React.PropsWithChildren<CheckboxGroupProps>>
}

export const Checkbox: ComposedCheckbox = connect(
  NextCheckbox,
  mapProps(
    {
      value: 'checked',
      onInput: 'onChange',
    },
    mapSize
  )
)

Checkbox.Group = connect(
  NextCheckbox.Group,
  mapProps(
    {
      dataSource: true,
    },
    mapSize
  ),
  mapReadPretty(PreviewText.Select, {
    mode: 'multiple',
  })
)

export default Checkbox
